export const loaderFeatureKey = 'loader'

import { createReducer, on } from '@ngrx/store'
import * as loaderActions from './loader.actions'

export interface LoaderState {
  active: number
  actionsInProgress: any[]
}

export interface LoaderPartialState {
  readonly [loaderFeatureKey]: LoaderState
}

export const initialState: LoaderState = {
  active: 0,
  actionsInProgress: [],
}

export const LoaderReducer = createReducer(
  initialState,
  on(loaderActions.setLoading, (state, action): LoaderState => {
    const isActionAlreadyInProgress = state.actionsInProgress.filter(
      (currentAction) => currentAction === action.id,
    ).length

    if (isActionAlreadyInProgress) {
      return state
    }

    const newActionsInProgress = [...state.actionsInProgress, action.id]
    return {
      ...state,
      active: newActionsInProgress.length,
      actionsInProgress: newActionsInProgress,
    }
  }),
  on(loaderActions.setLoadingComplete, (state, action): LoaderState => {
    const newActionsInProgress: any[] = state.actionsInProgress.filter(
      (currentAction: any) => currentAction !== action.id,
    )

    const newLoaderState: LoaderState = {
      ...state,
      active: newActionsInProgress.length,
      actionsInProgress: newActionsInProgress,
    }
    return newLoaderState
  }),
  on(loaderActions.clearActionsInProgress, (state) => initialState),
)
